
import './about.css';

import { Link } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  faBullseye,
  faLightbulb,
  faHeart,
  faChartLine,
  faBuilding,
  faLocationDot,
  faFileLines,
  faIdCard,
} from '@fortawesome/free-solid-svg-icons';

export const About = () => {
  return (
    <div className="general-container-footer-info-ab">

      <div className="info-footer-container-ab">

        {/* =====================================
            TITLU
        ===================================== */}

        <div className="tittle-ab-top">
          <h4>Despre noi</h4>
        </div>

        {/* =====================================
            MISIUNEA NOASTRA
        ===================================== */}

        <section className="section-about-2">

          <div className="part-image-about">
            <FontAwesomeIcon
              icon={faBullseye}
              className="icon-about-large"
              style={{ fontSize: '120px', color: '#13b8ab' }}
            />
          </div>

          <div className="part-text-about">

            <h4>Misiunea noastra</h4>

            <p>
              Ne propunem sa transformam contabilitatea dintr-un
              domeniu perceput adesea ca fiind rigid si greu de
              inteles, intr-o cunoastere clara, logica si accesibila
              pentru oricine, indiferent de varsta sau nivel
              de pregatire.
            </p>

            <p>
              Credem ca educatia financiara ar trebui sa fie usor
              de inteles si utila in viata de zi cu zi, nu o simpla
              insiruire de reguli de memorat.
            </p>

            <p>
              Prin lectii interactive si exemple practice, facem
              ca invatarea contabilitatii sa fie mai prietenoasa,
              mai relevanta si mai eficienta.
            </p>

          </div>

        </section>

        {/* =====================================
            ABORDAREA NOASTRA
        ===================================== */}

        <section className="section-about-2">

          <div className="part-text-about">

            <h4>Abordarea noastra</h4>

            <p>
              Noi nu doar predam contabilitate, ci redefinim
              modul in care oamenii o invata.
            </p>

            <p>
              Fiecare lectie este gandita sa fie interactiva,
              clara si pas cu pas, astfel incat sa intelegi
              logica din spatele numerelor, nu doar sa
              memorezi reguli.
            </p>

            <p>
              Aplicatia noastra se bazeaza pe feedback constant
              din partea utilizatorilor. Optimizam continutul
              in mod continuu pentru ca fiecare modul sa
              ofere rezultate reale si relevante.
            </p>

            <p>
              Cand informatia este prezentata clar si in context
              practic, conceptele financiare devin nu doar
              usor de inteles, ci si interesante.
            </p>

          </div>

          <div className="part-image-about">
            <FontAwesomeIcon
              icon={faLightbulb}
              className="icon-about-large"
              style={{ fontSize: '120px', color: '#13b8ab' }}
            />
          </div>

        </section>

        {/* =====================================
            DE CE EXISTAM
        ===================================== */}

        <section className="section-about-2">

          <div className="part-image-about">
            <FontAwesomeIcon
              icon={faHeart}
              className="icon-about-large"
              style={{ fontSize: '120px', color: '#13b8ab' }}
            />
          </div>

          <div className="part-text-about">

            <h4>De ce existam</h4>

            <p>
              Pentru ca contabilitatea nu trebuie sa fie
              grea, plictisitoare sau intimidanta.
            </p>

            <p>
              Credem ca educatia financiara este o superputere –
              una care ofera incredere, control si libertate.
            </p>

            <p>
              Si toata lumea merita acces la ea.
            </p>

          </div>

        </section>

        {/* =====================================
            IMBUNATATIRE CONTINUA
        ===================================== */}

        <section className="section-about-2">

          <div className="part-text-about">

            <h4>Imbunatatire continua</h4>

            <p>
              La ContaLearn, ne dedicam constant imbunatatirii.
              Intrebarile din quizuri si feedback-ul utilizatorilor
              ne ajuta sa intelegem cum progreseaza cursantii
              si ce putem face mai bine pentru a le oferi o
              experienta de invatare cat mai eficienta.
            </p>

            <p>
              Analizam rezultatele pentru a imbunatati lectiile
              existente si pentru a crea continut nou, mai clar
              si mai aplicat.
            </p>

            <p>
              Ne actualizam constant materialele pentru ca ele
              sa reflecte realitatile economice si contabile actuale.
            </p>

            <p>
              Scopul nostru este sa oferim o educatie financiara
              practica, accesibila si relevanta. La fel ca
              domeniul financiar, nici noi nu ramanem pe loc.
            </p>

          </div>

          <div className="part-image-about">
            <FontAwesomeIcon
              icon={faChartLine}
              className="icon-about-large"
              style={{ fontSize: '120px', color: '#13b8ab' }}
            />
          </div>

        </section>

        <div className="line-about"></div>

        {/* =====================================
            DATELE SOCIETATII
        ===================================== */}

        <section className="about-company-section">

          <div className="about-company-header">

            <div className="about-company-title">

              <FontAwesomeIcon
                icon={faBuilding}
                className="about-company-title-icon"
              />

              <h4>Datele societatii</h4>

            </div>

            <p>
              ContaLearn este administrata de CONTALEARN S.R.L.
              Mai jos sunt prezentate informatiile de identificare
              ale societatii.
            </p>

          </div>

          <div className="about-company-grid">

            <div className="about-company-item">

              <FontAwesomeIcon
                icon={faBuilding}
                className="about-company-item-icon"
              />

              <div>
                <span>Denumirea societatii</span>
                <strong>CONTALEARN S.R.L.</strong>
              </div>

            </div>

            <div className="about-company-item">

              <FontAwesomeIcon
                icon={faIdCard}
                className="about-company-item-icon"
              />

              <div>
                <span>Cod unic de inregistrare (CUI)</span>
                <strong>55705840</strong>
              </div>

            </div>

            <div className="about-company-item">

              <FontAwesomeIcon
                icon={faFileLines}
                className="about-company-item-icon"
              />

              <div>
                <span>Numar Registrul Comertului</span>
                <strong>J2026057859008</strong>
              </div>

            </div>

            <div className="about-company-item">

              <FontAwesomeIcon
                icon={faLocationDot}
                className="about-company-item-icon"
              />

              <div>
                <span>Sediul social</span>
                <strong>
                  Str. Sarmisegetuza nr. 16-17,
                  et. P, ap. SP 2,
                  Cluj-Napoca, jud. Cluj,
                  Romania
                </strong>
              </div>

            </div>

          </div>

          <div className="about-company-bottom">

            <p>
              Pentru intrebari legate de serviciile
              ContaLearn, ne poti contacta
              prin intermediul paginii dedicate.
            </p>

            <Link
              to="/ajutor"
              className="about-company-contact"
            >
              Contacteaza-ne
            </Link>

          </div>

        </section>

        {/* =====================================
            CONTACT / INTREBARI
        ===================================== */}

        <section className="section-cta-ab">

          <div className="cta-text-ab">

            <h4>Ai intrebari?</h4>

            <p>
              <Link to="/ajutor" className="cta-link-ab">
                Contacteaza-ne
              </Link>
              {' '}sau{' '}
              <Link to="/blog" className="cta-link-ab">
                viziteaza blogul nostru
              </Link>
              {' '}pentru mai multe resurse si raspunsuri.
            </p>

          </div>

          <Link to="/FAQ" className="buton-link-learn-ab">

            <div className="cta-action-ab">
              <span>Vezi intrebari frecvente!</span>
            </div>

          </Link>

        </section>

      </div>

    </div>
  );
};
